// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"file-locked"},"nodeName":"g","children":[{"attributes":{"id":"fill2","fill":"transparent","d":"M14.499 17.5H21.499V22H14.499V17.5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M20 10V7L15 2H4V22H10.5M14 2V8H20","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M15.75 17.5V15.75C15.75 14.5074 16.7574 13.5 18 13.5C19.2426 13.5 20.25 14.5074 20.25 15.75V17.5M14.499 17.5H21.499V22H14.499V17.5Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-file-locked')
export default class FileLockedIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'file-locked',
    }
  }
}
